import React from 'react';

const flagsContext = require.context('../../../assets/Flags', false, /\.svg$/);

function Flag({ countryCode }) {
  let flagSrc;
  try {
    flagSrc = flagsContext(`./${countryCode.toLowerCase()}.svg`);


  } catch (error) { 
    return null; 
  }

  return <img src={flagSrc} alt={`${countryCode}`} />;
}

export default Flag;